<div class="close-button">
    <app-button [buttonClasses]="'close-button'" (click)="close()" data-dismiss="modal">
        <span>Close Interactive</span>
    </app-button>
</div>
<div class="modal-body gtm-lti-continue-modal">
    <iframe
        class="interactive-iframe"
        #interactive
        [src]="interactiveMedia.canonicalUrl | bypassSecurity: 'resourceUrl'"
    ></iframe>
</div>
